import { inject, Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { catchError, switchMap, throwError } from 'rxjs';
import { NotificationService } from '../Notification/notification';
import { HttpHandlerFn } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorHandler {
  auth = inject(AuthService);
  notification = inject(NotificationService);

  private readonly LOGIN_URL = '/';

  handle(error: any, req: any, next: HttpHandlerFn) {
    switch (error.status) {
      case 401:
        if(req.url.includes(this.LOGIN_URL)) break;
        break;
      case 419:
        return this.handle401(req, next);
      case 403:
        // TODO: Handle 403 error (Forbidden) 07.09 повернути та зробити правильно
        this.notification.setMessage(`403 ${error.error.message}`); //{ severity: 'error', summary: 'Access Denied', detail: 'Not allowed.' }
        this.notification.display();
        break;
      case 404:
        this.notification.setMessage(`404 ${error.error.message}`); //{ severity: 'error', summary: 'Not Found', detail: 'Resource not found.' }
        this.notification.display();
        break;
      case 500:
        this.notification.setMessage(`500 ${error.error.message}`); //{ severity: 'error', summary: 'Server Error', detail: 'Try again later.' }
        this.notification.display();
        break;
      default:
        this.notification.setMessage(error.message); // { severity: 'error', summary: 'Error', detail: error.message }
        //this.notification.display();
    }

    return throwError(() => error);
  }

  private handle401(req: any, next: HttpHandlerFn) {
    return this.auth.refreshAuthToken().pipe(
      switchMap((newToken) => {
        const newReq = req.clone({
          setHeaders: { 'Authorization': `Bearer ${newToken.data.access_token}` },
        });
        return next(newReq);
      }),
      catchError((err) => {
        this.auth.badRefresh();
        return throwError(() => err);
      })
    );
  }
  
}
